import {
  supportTicketFilterData,
  SupportTicketFilterNames,
} from "@redotech/effect-api-shared/schema/support-ticket-filters";
import MailIcon from "@redotech/redo-icons/mail-01.svg";
import type { EffectApiContext } from "@redotech/redo-merchant-app-common/effect-api-client-provider";
import { ArrayStringFilterOperator } from "@redotech/redo-views-common/advanced-filters/array-string-filter";
import { AdvancedFilterType } from "@redotech/redo-views-common/advanced-filters/generic-advanced-filter-data";
import type { ArrayStringTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";
import { Effect } from "effect";

export function createInboxEmailAdvancedFilter(
  effectApi?: EffectApiContext,
): ArrayStringTableFilter<string> {
  return {
    type: AdvancedFilterType.ARRAY_TO_STRING,
    Icon: MailIcon,
    operators: [
      ArrayStringFilterOperator.ANY_OF,
      ArrayStringFilterOperator.NONE_OF,
    ],
    data: supportTicketFilterData[SupportTicketFilterNames.INBOX_EMAIL],
    itemLabel: "email",
    itemLabelPlural: "emails",
    displayName: "Received at email",
    valueFetcher: effectApi
      ? async (_params, _signal) => {
          const client = effectApi.getClient();
          const result = await effectApi.runPromise(
            client.integration
              .getTeamIntegrations({ urlParams: { limit: 100 } })
              .pipe(Effect.orDie),
          );
          const emails: string[] = [];
          for (const integration of result.items) {
            if (
              integration.integrationType === "gmail" ||
              integration.integrationType === "outlook" ||
              integration.integrationType === "custom_email"
            ) {
              const email = integration.channelData?.email;
              if (email) {
                emails.push(email.toLowerCase());
              }
            }
          }
          return [...new Set(emails)];
        }
      : undefined,
    display: (item: string) => item,
  };
}
